import { addAndTrack } from "../../calculators/helpers";
import { levels } from "../../configs";
import { bareLv } from "../../helpers";

export const wpSimpleAnTmaker = (target, paths, rootScale) => (args) => {
  const { wpRfm, tkDesc, tracker } = args;
  const rootValue = Array.isArray(rootScale)
    ? rootScale.map((scale) => scale * (wpRfm + 3))
    : rootScale * (wpRfm + 3);
  if (args[target])
    addAndTrack(tkDesc, args[target], paths, rootValue, tracker);
};

const baseAtkType = {
  23: [23, 56, 68, 102, 113, 130, 141, 158, 169, 185, 185, 185, 185, 185],
  33: [33, 80, 91, 139, 151, 174, 186, 209, 220, 243, 243, 243, 243, 243],
  38: [38, 86, 105, 151, 171, 193, 212, 234, 253, 274, 294, 314, 334, 354],
  39: [39, 94, 113, 169, 189, 216, 236, 263, 282, 309, 329, 355, 375, 401],
  40: [40, 102, 121, 187, 207, 239, 259, 292, 311, 344, 363, 396, 415, 448],
  41: [41, 99, 125, 184, 210, 238, 264, 293, 319, 347, 373, 401, 427, 454],
  42: [42, 109, 135, 205, 231, 266, 292, 327, 353, 388, 414, 449, 475, 510],
  44: [44, 119, 144, 226, 252, 293, 319, 361, 387, 429, 455, 497, 523, 565],
  "44b": [44, 110, 141, 210, 241, 275, 307, 341, 373, 408, 439, 475, 506, 542],
  46: [46, 122, 153, 235, 266, 308, 340, 382, 414, 457, 488, 532, 563, 608],
  45: [45, 128, 154, 247, 273, 321, 347, 395, 421, 470, 496, 545, 571, 620],
  48: [48, 133, 164, 261, 292, 341, 373, 423, 455, 506, 537, 590, 621, 674],
  49: [49, 145, 176, 286, 317, 374, 406, 464, 495, 555, 586, 648, 679, 741]
};

const subStatScale = {
  "3%": [3, 5.3, 7.7, 8.9, 10.1, 11.4, 12.6, 13.8],
  "3.4%": [3.4, 6, 8.8, 10.1, 11.5, 12.9, 14.2, 15.6],
  "3.6%": [3.6, 6.4, 9.3, 10.7, 12.2, 13.6, 15.1, 16.5],
  "4.5%": [4.5, 8, 11.6, 13.4, 15.2, 17, 18.9, 20.7],
  "4.8%": [4.8, 8.5, 12.4, 14.3, 16.2, 18.2, 20.1, 22.1],
  "5.1%": [5.1, 9, 13.1, 15.2, 17.3, 19.3, 21.4, 23.4],
  "6%": [6, 10.6, 15.5, 17.9, 20.3, 22.7, 25.1, 27.6],
  "6.4%": [6.4, 11.3, 16.4, 19, 21.6, 24.1, 26.7, 27.5],
  "6.7%": [6.7, 11.8, 17.2, 19.9, 22.6, 25.2, 27.9, 30.6],
  "6.8%": [6.8, 12, 17.5, 20.3, 23, 25.7, 28.5, 31.2],
  "7.2%": [7.2, 12.7, 18.5, 21.4, 24.4, 27.3, 30.2, 33.1],
  "7.5%": [7.5, 13.3, 19.3, 22.4, 25.4, 28.4, 31.5, 34.5],
  "7.7%": [7.7, 13.5, 19.7, 22.8, 25.9, 29, 32.1, 35.2],
  "8%": [8, 14.1, 20.6, 23.8, 27.1, 30.3, 33.5, 36.8],
  "8.5%": [8.5, 15, 21.9, 25.3, 28.8, 32.2, 35.6, 39],
  "9%": [9, 15.9, 23.2, 26.8, 30.4, 34.1, 37.7, 41.3],
  "9.6%a": [9.6, 16.9, 24.6, 28.5, 32.3, 36.2, 40.1, 43.9],
  "9.6%": [9.6, 17, 24.7, 28.6, 32.5, 36.3, 40.2, 44.1],
  "10%": [10, 17.7, 25.8, 29.8, 33.8, 37.9, 41.9, 45.9],
  "10.2%": [10.2, 18, 26.3, 30.4, 34.6, 38.6, 42.7, 46.9],
  "10.8%": [10.8, 19.1, 27.8, 32.2, 36.5, 40.9, 45.3, 49.6],
  "11.3%": [11.3, 20, 29, 33.5, 38.1, 42.6, 47.2, 51.7],
  "12%": [12, 21.2, 30.9, 35.7, 40.6, 45.4, 50.3, 55.1],
  "13.3%": [13.3, 23.6, 34.3, 39.7, 45.1, 50.5, 55.9, 61.3],
  "14.4%": [14.4, 25.5, 37.1, 42.9, 48.7, 54.5, 60.3, 66.2],
  "15%": [15, 26.5, 38.7, 44.7, 50.8, 56.8, 62.9, 69],
  "19.2%": [19.2, 33.9, 49.4, 57.2, 65, 72.7, 80.4, 88.2],
  12: [12, 21, 31, 36, 41, 45, 50, 55],
  20: [20, 36, 53, 61, 69, 77, 85, 94],
  24: [24, 42, 62, 71, 81, 91, 101, 110],
  31: [31, 54, 79, 91, 104, 116, 128, 141],
  36: [36, 64, 93, 107, 122, 136, 151, 165],
  41: [41, 72, 105, 122, 138, 154, 171, 187],
  43: [43, 76, 111, 129, 146, 164, 181, 198],
  48: [48, 85, 124, 143, 162, 182, 201, 221],
  58: [58, 102, 148, 172, 195, 218, 241, 265]
};

export const wpMainStatAtLv = (scale, lv) => {
  return baseAtkType[scale][levels.indexOf(lv)];
};

export const wpSubStatAtLv = (scale, lv) => {
  const curLv = bareLv(lv);
  const index = curLv === 1 ? 0 : curLv === 20 ? 1 : (curLv - 20) / 10;
  return subStatScale[scale][index];
};

export const GreenStats = {
  rarity: 2,
  mainStatScale: 33,
  pasvName: "",
  pasvDescs: () => []
};

export const GrayStats = {
  rarity: 1,
  mainStatScale: 23,
  pasvName: "",
  pasvDescs: () => []
};
